import React, { useState, useEffect, useCallback } from 'react';
import { Button, Spinner, Badge, Modal } from 'react-bootstrap';
import appUrl from '../../appUrl';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Table.css';
import { useParams } from 'react-router-dom';

const BookingTable = () => {
    const { name, businessId } = useParams();
    const AppUrl = appUrl();
    const [dataLoading, setDataLoading] = useState(false);
    const [projects, setProjects] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [deleteModal, setDeleteModal] = useState({ show: false, id: null });

    const handleAllBookings = useCallback( async () => {
        console.log("calling===2")
        setDataLoading(true);
        const token = localStorage.getItem("token");
        try {
            const response = await fetch(businessId ? `${AppUrl}/bookings/all?businessId=${businessId}` : `${AppUrl}/bookings/all`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });
            const data = await response.json();
            console.log(data, "dataaaaaa")
            if (data.status) {
                setProjects(data.data);
                setTotalCount(data.data.length);
            } else {
                toast.error("Failed to fetch data");
            }
        } catch (error) {
            console.error("Error fetching reports:", error);
            toast.error("Error fetching reports");
        } finally {
            setDataLoading(false);
        }
    }, [AppUrl]);

    const handlePageChange = (page, sizePerPage) => {
        setCurrentPage(page);
        setPageSize(sizePerPage);
    };

    useEffect(() => {
        console.log("calling===1")
        handleAllBookings();
    }, [handleAllBookings]);

    const columns = [
        {
            text: 'No.',
            dataField: 'index',
            formatter: (cell, row, rowIndex) => pageSize * (currentPage - 1) + rowIndex + 1
        },
        {
            text: 'Customer',
            dataField: 'customer.username',
            formatter: (cell) => {
                console.log("Cell Value:", cell); // Logs the value of the cell
                return cell ? cell.charAt(0).toUpperCase() + cell.slice(1) : '';
            },
            filter: textFilter({ placeholder: '' })
        },
        {
            text: 'Business',
            dataField: 'business.business_name',
            filter: textFilter({ placeholder: '' })
        },
        {
            text: 'Order Number',
            dataField: 'order_number',
            filter: textFilter({ placeholder: '' })
        },
        {
            text: 'DateTime',
            dataField: 'bookingDateTime',
            filter: textFilter({ placeholder: '' }),
            formatter: (cell) => {
                if (!cell) return '-';
                return new Date(cell).toLocaleString('en-US', { 
                    year: 'numeric', 
                    month: 'short', 
                    day: '2-digit', 
                    hour: '2-digit', 
                    minute: '2-digit', 
                    hour12: true 
                });
            }
        },
        {
            text: 'Request',
            dataField: 'special_request',
            filter: textFilter({ placeholder: '' }),
            formatter: (cell) => cell || '-'
        },
        {
            text: 'Location',
            dataField: 'customer_location',
            filter: textFilter({ placeholder: '' }),
        },
        {
            text: 'Status',
            dataField: 'booking_status',
            filter: textFilter({ placeholder: '' }),
            formatter: (cell) => {
                if (!cell) return <Badge variant="secondary">Unknown</Badge>;

                const statusMap = {
                    pending: { label: "Pending", variant: "warning" },
                    accepted: { label: "Scheduled", variant: "success" },
                    cancelled: { label: "Cancelled", variant: "secondary" },
                    rejected: { label: "Rejected", variant: "danger" },
                    completed: { label: "Completed", variant: "primary" }
                };

                const status = statusMap[cell] || { label: "Unknown", variant: "secondary" };
                return <Badge className='status-badge' bg={status.variant}>{status.label}</Badge>;
            }
        },
        {
            text: 'Action',
            formatter: (cell, row) => {
                return (
                    <Button className="view-details-button-lg py-2" 
                    //onClick={() => setDeleteModal({ show: true, id: row._id })}
                    >
                        View
                    </Button>
                );
            }
        }
        
    ];

    return (
        <>
            <ToastContainer />
            {dataLoading ? (
                <div className='loading-spinner'>
                    <Spinner animation="border" role="status" />
                </div>
            ) : (
                <>
                    {name && <div className='text-lg'>
                        <span>
                            Bookings for Business:
                        </span>
                        <span className='font-bold mx-1'>
                            {name}
                        </span>
                    </div>}
                    <BootstrapTable
                        bootstrap4
                        keyField="_id"
                        data={projects}
                        columns={columns}
                        filter={filterFactory()}
                        pagination={paginationFactory({
                            page: currentPage,
                            sizePerPage: pageSize,
                            totalSize: totalCount,
                            onPageChange: handlePageChange,
                            sizePerPageRenderer: () => null,
                            showTotal: true,
                            paginationTotalRenderer: (from, to, total) => (
                                <div className="pagination-and-entries">
                                    <p className="entries">
                                        Showing {from} to {to} of {total} entries
                                    </p>
                                </div>
                            )
                        })}
                    />
                </>
            )}

            <Modal
                show={deleteModal.show}
                onHide={() => setDeleteModal({ show: false, id: null })}>
                <Modal.Header closeButton>
                    <Modal.Title>Cancel Booking</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to cancel this booking? (ID: <strong>{deleteModal.id}</strong>)
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setDeleteModal({ show: false, id: null })}>
                        Close
                    </Button>
                    <Button variant="danger" onClick={() => console.log("Cancelling:", deleteModal.id)}>
                        Confirm Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default BookingTable;
